import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  // Se il bootstrap fallisce non lasciamo uno schermo bianco muto: logghiamo
  // e mostriamo un messaggio minimale con possibilità di ricaricare.
  console.error('Bootstrap fallito:', err);
  const root = document.querySelector('app-root');
  if (root) {
    root.innerHTML =
      '<div style="font-family:system-ui;padding:2rem;max-width:32rem;margin:3rem auto;text-align:center">' +
      '<h2>Impossibile avviare l\'applicazione</h2>' +
      '<p>Si è verificato un errore in fase di inizializzazione.</p>' +
      '<button onclick="location.reload()" style="padding:.5rem 1rem;cursor:pointer">Ricarica</button>' +
      '</div>';
  }
});
